import React from "react";
import { ClubEvent } from "../types";
import { icsUrl, googleCalUrl } from "../utils/calendar";

// ── Lisää kalenteriin ─────────────────────────────────────────
//
// Sama pari pelaajan tapahtumasivulla ja ylläpitäjän kutsunäkymässä.
// Aiemmin napit olivat kaksi täysväristä laattaa (Google-sininen ja
// Apple-musta), jotka riitelivät kortin muiden painikkeiden kanssa.
// Nyt ne ovat huoliteltuja rivejä: palvelun merkki, kaksi tekstiriviä
// ja nuoli, teeman omilla pinnoilla.

const F = { heading: "'Rajdhani', sans-serif", body: "'Sora', sans-serif" };

const row: React.CSSProperties = {
  display: "flex", alignItems: "center", gap: 10, textDecoration: "none",
  padding: "9px 10px 9px 9px", borderRadius: 12,
  border: "1px solid var(--sl-border)", background: "var(--sl-soft)", color: "var(--sl-text)",
  minWidth: 0,
};
const badge: React.CSSProperties = {
  width: 34, height: 34, borderRadius: 10, flexShrink: 0,
  display: "inline-flex", alignItems: "center", justifyContent: "center",
};

const CalendarButtons: React.FC<{ event: ClubEvent; lang?: "fi" | "en" }> = ({ event, lang = "fi" }) => {
  const d = new Date(event.datetime);
  const weekday = d.toLocaleString("fi-FI", { weekday: "short" }).toUpperCase().replace(".", "");
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
      <a href={googleCalUrl(event)} target="_blank" rel="noreferrer" style={row}>
        <span style={{ ...badge, background: "#ffffff", border: "1px solid var(--sl-border)" }}>
          <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
            <path fill="#4285F4" d="M45.1 24.5c0-1.6-.1-2.8-.4-4.1H24v7.5h12.1c-.3 2-1.6 5-4.6 7l7 5.4c4.2-3.9 6.6-9.6 6.6-15.8z"></path>
            <path fill="#34A853" d="M24 46c6 0 11-2 14.6-5.4l-7-5.4c-1.9 1.3-4.4 2.2-7.6 2.2-5.8 0-10.8-3.9-12.5-9.4l-7.3 5.6C7.8 40.8 15.3 46 24 46z"></path>
            <path fill="#FBBC05" d="M11.5 28c-.5-1.3-.7-2.6-.7-4s.3-2.7.7-4l-7.3-5.6C2.8 17 2 20.4 2 24s.8 7 2.2 9.6L11.5 28z"></path>
            <path fill="#EA4335" d="M24 10.6c3.3 0 5.5 1.4 6.8 2.6l5-4.9C32.9 5.5 29 3.9 24 3.9c-8.7 0-16.2 5.2-19.8 12.5l7.3 5.6c1.7-5.5 6.7-9.4 12.5-9.4z"></path>
          </svg>
        </span>
        <span style={{ display: "flex", flexDirection: "column", lineHeight: 1.15, minWidth: 0 }}>
          <span style={{ fontSize: 10, color: "var(--sl-muted)", fontWeight: 600, fontFamily: F.body }}>{lang === "fi" ? "Lisää kalenteriin" : "Add to calendar"}</span>
          <span style={{ fontSize: 13, fontWeight: 700, fontFamily: F.body }}>Google</span>
        </span>
      </a>
      <a href={icsUrl(event)} target="_blank" rel="noreferrer" style={row}>
        <span style={{ ...badge, background: "#ffffff", border: "1px solid var(--sl-border)", flexDirection: "column", overflow: "hidden", padding: 0 }}>
          <span style={{ width: "100%", background: "#ff3b30", color: "#fff", fontSize: 7, fontWeight: 800, textAlign: "center", lineHeight: "11px", fontFamily: F.body }}>{weekday}</span>
          <span style={{ fontSize: 15, fontWeight: 800, color: "#1c1c1e", lineHeight: "22px", fontFamily: F.heading }}>{d.getDate()}</span>
        </span>
        <span style={{ display: "flex", flexDirection: "column", lineHeight: 1.15, minWidth: 0 }}>
          <span style={{ fontSize: 10, color: "var(--sl-muted)", fontWeight: 600, fontFamily: F.body }}>{lang === "fi" ? "Lisää kalenteriin" : "Add to calendar"}</span>
          <span style={{ fontSize: 13, fontWeight: 700, fontFamily: F.body }}>Apple / ICS</span>
        </span>
      </a>
    </div>
  );
};

export default CalendarButtons;
